import { render, staticRenderFns } from "./c-Subjek.vue?vue&type=template&id=65017fcc&scoped=true&"
import script from "./c-Subjek.vue?vue&type=script&lang=js&"
export * from "./c-Subjek.vue?vue&type=script&lang=js&"
import style0 from "./c-Subjek.vue?vue&type=style&index=0&id=65017fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65017fcc",
  null
  
)

export default component.exports